// File for logic corresponding to article component
import { Component } from 'js-component-framework';
import article from '../article/article';

/**
 * Component for a article header.
 */
export default class ArticleHeader extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { slideshowBlock, galleryBlock } = this.children;
    const { slideshowCaptionClass, galleryCaptionClass } = this.options;

    article.setCaptionClamp(slideshowBlock, slideshowCaptionClass);
    article.setCaptionClamp(galleryBlock, galleryCaptionClass);
  }
}
